"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NODE_ICONS = exports.NodeIconsDict = void 0;

var the_lodash_1 = __importDefault(require("the-lodash"));

var node_dict_1 = require("./node-dict");

var node_kind_1 = require("./entities/node-kind");

var NodeIconsDict =
/** @class */
function (_super) {
  __extends(NodeIconsDict, _super);

  function NodeIconsDict() {
    var _this = _super.call(this) || this;

    _this._apiServiceDict = {};
    _this._k8sClusteredCoreDict = {};
    _this._k8sClusteredApiDict = {};
    _this._k8sNamespacedCoreDict = {};
    _this._k8sNamespacedApiDict = {};
    _this._k8sUnknownIcon = _this._k8sIconPath('unknown.svg');

    _this._setupK8s();

    _this._setupLogic();

    _this._setupInfra();

    _this._setupImages();

    _this._setupGateway();

    _this._setupPackage();

    _this._setupRBAC();

    _this._setup3rdParty();

    return _this;
  }

  NodeIconsDict.prototype._setupK8s = function () {
    this.setKind(node_kind_1.NodeKind.cluster, this._iconPath('api-cluster.svg'));
    this.setKind(node_kind_1.NodeKind.api, this._handleApi.bind(this));
    this.setKind(node_kind_1.NodeKind.version, this._iconPath('api-version.svg'));
    /*** INITIAL SETUP ***/

    /* K8s :: Cluster :: Core */

    this._setK8sClusteredCore('Namespace', 'ns.svg');

    this._setK8sClusteredCore('Node', 'node.svg');

    this._setK8sClusteredCore('PersistentVolume', 'pv.svg');
    /* K8s :: Cluster :: RBAC */


    this._setK8sClusteredApi('rbac.authorization.k8s.io', 'ClusterRoleBinding', 'crb.svg');

    this._setK8sClusteredApi('rbac.authorization.k8s.io', 'ClusterRole', 'c-role.svg');
    /* K8s :: Cluster :: Policy */


    this._setK8sClusteredApi('policy', 'PodSecurityPolicy', 'psp.svg');
    /* K8s :: Namespace :: Core */


    this._setK8sNamespacedCore('ConfigMap', 'cm.svg');

    this._setK8sNamespacedCore('Pod', 'pod.svg');

    this._setK8sNamespacedCore('ServiceAccount', 'sa.svg');

    this._setK8sNamespacedCore('Service', 'svc.svg');

    this._setK8sNamespacedCore('PersistentVolumeClaim', 'pvc.svg');

    this._setK8sNamespacedCore('Secret', 'secret.svg');

    this._setK8sNamespacedCore('LimitRange', 'limits.svg');

    this._setK8sNamespacedCore('ResourceQuota', 'quota.svg');

    this._setK8sNamespacedCore('Endpoints', 'ep.svg');

    this._setK8sNamespacedCore('Event', 'event.svg');
    /* K8s :: Namespace :: App */


    this._setK8sNamespacedApi('apps', 'Deployment', 'deploy.svg');

    this._setK8sNamespacedApi('apps', 'DaemonSet', 'ds.svg');

    this._setK8sNamespacedApi('apps', 'StatefulSet', 'sts.svg');

    this._setK8sNamespacedApi('apps', 'ReplicaSet', 'rs.svg');
    /* K8s :: Namespace :: batch */


    this._setK8sNamespacedApi('batch', 'Job', 'job.svg');

    this._setK8sNamespacedApi('batch', 'CronJob', 'cronjob.svg');
    /* K8s :: Namespace :: autoscaling */


    this._setK8sNamespacedApi('autoscaling', 'HorizontalPodAutoscaler', 'hpa.svg');
    /* K8s :: Namespace :: extensions */


    this._setK8sNamespacedApi('extensions', 'Ingress', 'ing.svg');
    /* K8s :: Namespace :: RBAC */


    this._setK8sNamespacedApi('rbac.authorization.k8s.io', 'RoleBinding', 'rb.svg');

    this._setK8sNamespacedApi('rbac.authorization.k8s.io', 'Role', 'role.svg');
    /* K8s :: Namespace :: Networking */


    this._setK8sNamespacedApi('networking.k8s.io', 'NetworkPolicy', 'netpol.svg');

    this._setK8sNamespacedApi('networking.k8s.io', 'Ingress', 'ing.svg');

    this._setK8sNamespacedApi('networking.k8s.io', 'IngressClass', 'ing.svg');
    /* K8s :: Namespace :: Discovery */


    this._setK8sNamespacedApi('discovery.k8s.io', 'EndpointSlice', 'ep.svg');
    /* K8s :: Namespace :: Storage */


    this._setK8sNamespacedApi('storage.k8s.io', 'VolumeAttachment', 'vol.svg');
    /*** *** *** *** ***/


    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.cluster, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind], this._handleK8sClusteredCore.bind(this));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.cluster, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind, node_kind_1.NodeKind.resource], this._handleK8sClusteredCore.bind(this));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.cluster, node_kind_1.NodeKind.api, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind], this._handleK8sClusteredApi.bind(this));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.cluster, node_kind_1.NodeKind.api, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind, node_kind_1.NodeKind.resource], this._handleK8sClusteredApi.bind(this));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.ns, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind], this._handleK8sNamespacedCore.bind(this));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.ns, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind, node_kind_1.NodeKind.resource], this._handleK8sNamespacedCore.bind(this));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.ns, node_kind_1.NodeKind.api, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind], this._handleK8sNamespacedApi.bind(this));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.ns, node_kind_1.NodeKind.api, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind, node_kind_1.NodeKind.resource], this._handleK8sNamespacedApi.bind(this)); // Unused Icons:
    // - crd.svg
    // - group.svg
    // - sc.svg
    // - user.svg
  };

  NodeIconsDict.prototype._handleApi = function (dnParts) {
    var api = the_lodash_1.default.last(dnParts);

    if (api.name) {
      var icon = this._apiServiceDict[api.name];

      if (icon) {
        return icon;
      }
    }

    return this._k8sIconPath('api.svg');
  };

  NodeIconsDict.prototype._handleK8sClusteredCore = function (dnParts) {
    var _a;

    var kind = dnParts[4].name;
    return (_a = this._k8sClusteredCoreDict[kind]) !== null && _a !== void 0 ? _a : this._k8sUnknownIcon;
  };

  NodeIconsDict.prototype._handleK8sClusteredApi = function (dnParts) {
    var _a;

    var api = dnParts[3].name;
    var kind = dnParts[5].name;
    var apiDict = this._k8sClusteredApiDict[api];

    if (!apiDict) {
      return this._k8sUnknownIcon;
    }

    return (_a = apiDict[kind]) !== null && _a !== void 0 ? _a : this._k8sUnknownIcon;
  };

  NodeIconsDict.prototype._handleK8sNamespacedCore = function (dnParts) {
    var _a;

    var kind = dnParts[4].name;
    return (_a = this._k8sNamespacedCoreDict[kind]) !== null && _a !== void 0 ? _a : this._k8sUnknownIcon;
  };

  NodeIconsDict.prototype._handleK8sNamespacedApi = function (dnParts) {
    var _a;

    var api = dnParts[3].name;
    var kind = dnParts[5].name;
    var apiDict = this._k8sNamespacedApiDict[api];

    if (!apiDict) {
      return this._k8sUnknownIcon;
    }

    return (_a = apiDict[kind]) !== null && _a !== void 0 ? _a : this._k8sUnknownIcon;
  };

  NodeIconsDict.prototype._setupInfra = function () {
    var _this = this;

    this.setKind(node_kind_1.NodeKind.k8s, this._k8sIconPath('api.svg'));
    this.setKind(node_kind_1.NodeKind.infra, this._iconPath('infra/infra.svg'));
    this.setKind(node_kind_1.NodeKind.nodes, this._iconPath('infra/nodes.svg'));
    this.setKind(node_kind_1.NodeKind.pool, this._iconPath('infra/pool.svg'));
    this.setKind(node_kind_1.NodeKind.node, this._k8sIconPath('node.svg'));
    this.setKind(node_kind_1.NodeKind.storage, this._iconPath('infra/storage.svg'));
    this.setKind(node_kind_1.NodeKind.storclass, this._iconPath('infra/storclass.svg'));
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.infra, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.api, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind], function (dnParts) {
      var api = dnParts[3].name;
      var kind = dnParts[5].name;
      {
        var apiDict = _this._k8sClusteredApiDict[api];

        if (apiDict) {
          var value = apiDict[kind];

          if (value) {
            return value;
          }
        }
      }
      {
        var apiDict = _this._k8sNamespacedApiDict[api];

        if (apiDict) {
          var value = apiDict[kind];

          if (value) {
            return value;
          }
        }
      }
      return _this._k8sUnknownIcon;
    });
    this.setPath([node_kind_1.NodeKind.root, node_kind_1.NodeKind.infra, node_kind_1.NodeKind.k8s, node_kind_1.NodeKind.version, node_kind_1.NodeKind.kind], function (dnParts) {
      var kind = dnParts[4].name;
      {
        var value = _this._k8sClusteredCoreDict[kind];

        if (value) {
          return value;
        }
      }
      {
        var value = _this._k8sNamespacedCoreDict[kind];

        if (value) {
          return value;
        }
      }
      return _this._k8sUnknownIcon;
    });
  };

  NodeIconsDict.prototype._setupLogic = function () {
    var _this = this;

    this.setKind(node_kind_1.NodeKind.logic, this._iconPath('logic/logic.svg'));
    this.setKind(node_kind_1.NodeKind.app, this._iconPath('logic/app.svg'));
    this.setKind(node_kind_1.NodeKind.cont, this._iconPath('logic/cont.svg'));
    this.setKind(node_kind_1.NodeKind.initcont, this._iconPath('logic/initcont.svg'));
    this.setKind(node_kind_1.NodeKind.port, this._iconPath('logic/port.svg'));
    this.setKind(node_kind_1.NodeKind.image, this._iconPath('logic/image.svg'));
    this.setKind(node_kind_1.NodeKind.vols, this._k8sIconPath('vol.svg'));
    this.setKind(node_kind_1.NodeKind.vol, this._k8sIconPath('vol.svg'));
    this.setKind(node_kind_1.NodeKind.mounts, this._iconPath('logic/mounts.png'));
    this.setKind(node_kind_1.NodeKind.mount, this._iconPath('logic/mount.png'));
    this.setKind(node_kind_1.NodeKind.ns, this._k8sIconPath('ns.svg'));
    this.setKind(node_kind_1.NodeKind.secret, this._k8sIconPath('secret.svg'));
    this.setKind(node_kind_1.NodeKind.configmap, this._k8sIconPath('cm.svg'));
    this.setKind(node_kind_1.NodeKind.replicaset, this._k8sIconPath('rs.svg'));
    this.setKind(node_kind_1.NodeKind.hpa, this._k8sIconPath('hpa.svg'));
    this.setKind(node_kind_1.NodeKind.svcaccnt, this._k8sIconPath('sa.svg'));
    this.setKind(node_kind_1.NodeKind.rlbndg, this._k8sIconPath('rb.svg'));
    this.setKind(node_kind_1.NodeKind.crlbndg, this._k8sIconPath('crb.svg'));
    this.setKind(node_kind_1.NodeKind.rl, this._k8sIconPath('role.svg'));
    this.setKind(node_kind_1.NodeKind.crl, this._k8sIconPath('c-role.svg'));
    this.setKind(node_kind_1.NodeKind.pv, this._k8sIconPath('pv.svg'));
    this.setKind(node_kind_1.NodeKind.pvc, this._k8sIconPath('pvc.svg'));
    this.setKind(node_kind_1.NodeKind.psp, this._k8sIconPath('psp.svg'));
    this.setKind(node_kind_1.NodeKind.netpols, this._k8sIconPath('netpol.svg'));
    this.setKind(node_kind_1.NodeKind.netpol, this._k8sIconPath('netpol.svg'));
    this.setKind(node_kind_1.NodeKind.service, this._k8sIconPath('svc.svg'));
    this.setKind(node_kind_1.NodeKind.ingress, this._k8sIconPath('ing.svg'));
    this.setKind(node_kind_1.NodeKind.pod, this._k8sIconPath('pod.svg'));
    this.setKind(node_kind_1.NodeKind.job, this._k8sIconPath('job.svg'));
    this.setKind(node_kind_1.NodeKind.cronjob, this._k8sIconPath('cronjob.svg'));
    this.setKind(node_kind_1.NodeKind.launcher, function (dnParts) {
      var kind = the_lodash_1.default.last(dnParts).name;

      switch (kind) {
        case 'Deployment':
          return _this._k8sIconPath('deploy.svg');

        case 'DaemonSet':
          return _this._k8sIconPath('ds.svg');

        case 'StatefulSet':
          return _this._k8sIconPath('sts.svg');

        case 'Job':
          return _this._k8sIconPath('job.svg');

        case 'CronJob':
          return _this._k8sIconPath('cronjob.svg');

        case 'ReplicaSet':
          return _this._k8sIconPath('rs.svg');

        case 'Pod':
          return _this._k8sIconPath('pod.svg');
      }

      return _this._iconPath('logic/launcher.svg');
    });
  };

  NodeIconsDict.prototype._setupImages = function () {
    this.setKind(node_kind_1.NodeKind.images, this._iconPath('images/images.svg'));
    this.setKind(node_kind_1.NodeKind.repo, this._iconPath('images/repository.svg'));
    this.setKind(node_kind_1.NodeKind.tag, this._iconPath('images/tag.svg'));
  };

  NodeIconsDict.prototype._setupGateway = function () {
    this.setKind(node_kind_1.NodeKind.gateway, this._iconPath('gateway/gateway.png'));
    this.setKind(node_kind_1.NodeKind.domain, this._iconPath('gateway/domain.png'));
    this.setKind(node_kind_1.NodeKind.url, this._iconPath('gateway/url.png'));
  };

  NodeIconsDict.prototype._setupPackage = function () {
    this.setKind(node_kind_1.NodeKind.pack, this._iconPath('pack/pack.png'));
    this.setKind(node_kind_1.NodeKind.helm, this._iconPath('pack/helm.svg'));
  };

  NodeIconsDict.prototype._setupRBAC = function () {
    this.setKind(node_kind_1.NodeKind.rbac, this._iconPath('rbac/rbac.svg'));
    this.setKind(node_kind_1.NodeKind.user, this._iconPath('rbac/user.svg'));
    this.setKind(node_kind_1.NodeKind.group, this._iconPath('rbac/group.svg'));
  };

  NodeIconsDict.prototype._setup3rdParty = function () {
    this._setupTraefik();
  };

  NodeIconsDict.prototype._setupTraefik = function () {
    {
      var icon = this._iconPath('3rdparty/traefik/traefik.svg');

      this._apiServiceDict['traefik.containo.us'] = icon;
    }
    {
      var icon = this._iconPath('3rdparty/traefik/traefik-ingress-route.svg');

      this._setNamespacedApi('traefik.containo.us', 'IngressRoute', icon);

      this.setKind(node_kind_1.NodeKind.traefik_ingress_route, icon);
    }
    {
      var icon = this._iconPath('3rdparty/traefik/traefik-service.svg');

      this._setNamespacedApi('traefik.containo.us', 'TraefikService', icon);

      this.setKind(node_kind_1.NodeKind.traefik_service, icon);
    }
    {
      var icon = this._iconPath('3rdparty/traefik/traefik-middleware.svg');

      this._setNamespacedApi('traefik.containo.us', 'Middleware', icon);

      this.setKind(node_kind_1.NodeKind.traefik_middleware, icon);
    }
    {
      var icon = this._iconPath('3rdparty/traefik/traefik-tls-options.svg');

      this._setNamespacedApi('traefik.containo.us', 'TLSOption', icon);

      this.setKind(node_kind_1.NodeKind.traefik_tls_opts, icon);
    }
  }; //


  NodeIconsDict.prototype._setK8sClusteredCore = function (kind, icon) {
    this._k8sClusteredCoreDict[kind] = this._k8sIconPath(icon);
  };

  NodeIconsDict.prototype._setK8sClusteredApi = function (api, kind, icon) {
    if (!this._k8sClusteredApiDict[api]) {
      this._k8sClusteredApiDict[api] = {};
    }

    this._k8sClusteredApiDict[api][kind] = this._k8sIconPath(icon);
  };

  NodeIconsDict.prototype._setK8sNamespacedCore = function (kind, icon) {
    this._k8sNamespacedCoreDict[kind] = this._k8sIconPath(icon);
  };

  NodeIconsDict.prototype._setK8sNamespacedApi = function (api, kind, icon) {
    this._setNamespacedApi(api, kind, this._k8sIconPath(icon));
  };

  NodeIconsDict.prototype._setNamespacedApi = function (api, kind, iconPath) {
    if (!this._k8sNamespacedApiDict[api]) {
      this._k8sNamespacedApiDict[api] = {};
    }

    this._k8sNamespacedApiDict[api][kind] = iconPath;
  };

  NodeIconsDict.prototype._k8sIconPath = function (x) {
    return this._iconPath("k8s/" + x);
  };

  NodeIconsDict.prototype._iconPath = function (x) {
    return "/img/entities/" + x;
  };

  NodeIconsDict.prototype._getDefaultValue = function (dn) {
    return this._iconPath('unknown.svg');
  };

  return NodeIconsDict;
}(node_dict_1.NodeDict);

exports.NodeIconsDict = NodeIconsDict;
exports.NODE_ICONS = new NodeIconsDict();